GeneralInfoRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function GeneralInfoRouting($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise("/GeneralInfo/List");

    $stateProvider

        .state('GeneralInfo', {

            abstract: true,

            url: '/GeneralInfo',

            template: '<ui-view id="GeneralInfo"></ui-view>'

        })

        .state('GeneralInfo.List', {

            url: '/List',

            controller: 'GeneralInfo.ListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./List/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./List/List.module');

                        $ocLazyLoad.load({

                            name: 'ListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "تکمیل اطلاعات",
                icon: "fas fa-tasks"
            }

        })
        .state('GeneralInfo.JobExperience', {

            url: '/JobExperience',

            controller: 'GeneralInfo.JobExperienceController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./JobExperience/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./JobExperience/JobExperience.module');

                        $ocLazyLoad.load({

                            name: 'JobExperienceModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.Certificates', {

            url: '/Certificates',

            controller: 'GeneralInfo.CertificatesController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Certificates/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Certificates/Certificates.module');

                        $ocLazyLoad.load({

                            name: 'CertificatesModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "گواهینامه ها",
                icon: "fas fa-object-group"
            }

        })
        .state('GeneralInfo.TeachingHistory', {

            url: '/TeachingHistory',

            controller: 'GeneralInfo.TeachingHistoryController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./TeachingHistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./TeachingHistory/TeachingHistory.module');

                        $ocLazyLoad.load({

                            name: 'TeachingHistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.EducationalHistory', {

            url: '/EducationalHistory',

            controller: 'GeneralInfo.EducationalHistoryController',

            controllerAs: 'self',


            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./EducationalHistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./EducationalHistory/EducationalHistory.module');

                        $ocLazyLoad.load({

                            name: 'EducationalHistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.Skillhistory', {

            url: '/Skillhistory',

            controller: 'GeneralInfo.SkillhistoryController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Skillhistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Skillhistory/Skillhistory.module');

                        $ocLazyLoad.load({

                            name: 'SkillhistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.ResearchHistory', {

            url: '/ResearchHistory',

            controller: 'GeneralInfo.ResearchHistoryController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ResearchHistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ResearchHistory/ResearchHistory.module');

                        $ocLazyLoad.load({

                            name: 'ResearchHistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.UploadDocument', {

            url: '/UploadDocument',

            controller: 'GeneralInfo.UploadDocumentController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./UploadDocument/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./UploadDocument/UploadDocument.module');

                        $ocLazyLoad.load({

                            name: 'UploadDocumentModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.Inventions', {

            url: '/Inventions',

            controller: 'GeneralInfo.InventionsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Inventions/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Inventions/Inventions.module');

                        $ocLazyLoad.load({

                            name: 'InventionsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.Acknowledgments', {

            url: '/Acknowledgments',

            controller: 'GeneralInfo.AcknowledgmentsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Acknowledgments/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Acknowledgments/Acknowledgments.module');

                        $ocLazyLoad.load({

                            name: 'AcknowledgmentsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.Contact', {

            url: '/Contact',

            controller: 'GeneralInfo.ContactController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Contact/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Contact/Contact.module');

                        $ocLazyLoad.load({

                            name: 'ContactModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            }

        })
        .state('GeneralInfo.Support', {

            url: '/Support',

            controller: 'GeneralInfo.SupportController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Support/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Support/Support.module');

                        $ocLazyLoad.load({

                            name: 'SupportModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "پشتیبانی",
                icon: "fas fa-question"
            }

        })
        .state('GeneralInfo.ServiceHistory', {

            url: '/ServiceHistory',

            controller: 'GeneralInfo.ServiceHistoryController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ServiceHistory/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ServiceHistory/ServiceHistory.module');

                        $ocLazyLoad.load({

                            name: 'ServiceHistoryModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "پروژه ها",
                icon: "fas fa-server"
            }

        })
        .state('GeneralInfo.CompanyInformation', {

            url: '/CompanyInformation',

            controller: 'GeneralInfo.CompanyInformationController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./CompanyInformation/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./CompanyInformation/CompanyInformation.module');

                        $ocLazyLoad.load({

                            name: 'CompanyInformationModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "اطلاعات شرکت",
                icon: "fas fa-info-circle"
            }

        })
        .state('GeneralInfo.Services', {

            url: '/Services',

            controller: 'GeneralInfo.ServicesController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Services/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Services/Services.module');

                        $ocLazyLoad.load({

                            name: 'ServicesModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "خدمات",
                icon: "fas fa-info-circle"
            }

        })
        .state('GeneralInfo.EditService', {

            url: '/EditService/:serviceId',

            controller: 'GeneralInfo.EditServiceController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./EditService/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./EditService/EditService.module');

                        $ocLazyLoad.load({

                            name: 'EditServiceModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "ویرایش",
                icon: "fas fa-info-circle"
            }
        })/*endOfResolve*/;

}



export default GeneralInfoRouting;
